import { registerPlugin } from '@capacitor/core';
const WidgetBridgePlugin = registerPlugin('WidgetBridgePlugin');
export * from './definitions';
export { WidgetBridgePlugin };
//# sourceMappingURL=index.js.map